import cmsFetch from '~/helpers/cms-fetch';
export default cmsFetch('salesforce/partners');
